<template>
  <div id="contact" class="section_Bot">
    <div class=" content ">
    <div class="px-5 pt-3">
      <p class="title pt-5 pl-5" v-html="$t('contact.content.agradecimientos.titulo')"></p>
      <p class="pt-sm-3 text pl-5 space" v-html="$t('contact.content.agradecimientos.text')"></p>
    </div>
      <div class="row">
        <div class="col-3"></div>
        <div class="col-6">
          <p class="pt-sm-3 text fraseCafe pl-5 space" v-html="$t('contact.content.fraseCafe')"></p>
        </div>
      </div>
      <div class="row pt-5 talk px-5">
        <!-- <div class="col-5"></div> -->
        <div class="col-2">
           <p class="btn-submit float-center pl-5" @click="sendForm">
             <a>{{ 'contact.content.botonAtras' | translate }}</a>
          </p>
        </div>
      </div>
    </div>
    <Footer class=""></Footer>
  </div>
</template>

<script>
  import Footer from '../components/Footer.vue'
  export default {
    name: 'Gratitude',
    components: { Footer },
    data () {
      return {
      }
    },
    methods: {
      sendForm: function () {
        this.$router.push({name: 'Contact'})
        this.$emit('back', '')
      }
    },
    computed: {
    }
  }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @import '../assets/styles/colors.scss';
  #contact{
    height: 100%;

  }

  .content{
    padding-top:5%;
    padding-left: 5%;
    padding-right: 10%;
    height: 97vh;
  }

  .text {
    font-family: "Open Sans", sans-serif;
    color: #00839E;
    text-align: left;
    font-size: 1.1rem;

    @media (min-width: 1400px) {
      font-size: 1.3rem;
    }
    .title {
      border-top: 1px solid rgba(29, 141, 161, 0.2);
      color: #00739C;
      font-weight: 600;
      font-size: 1.5rem;
      //text-transform: uppercase;

      @media (min-width: 1400px) {
        font-size: 1.9rem;
      }
    }
    .fraseCafe{
      font-size: 1.5rem;
      font-style: italic;
      text-align: right;
    }
  }

  .section_Bot{
    background-color: #FFFFFF;
   padding: 0px;
  }


  .space{
    @media (min-width: 994px) {
      padding-right: 100px;
    }
  }

  .border-class{
    background-color: #EFF7FB;
    width: 35%;
    height: calc(2.25rem + 10px);
    color: #60BDC5;
    border: 2px solid;
   // padding: 10px;
    border-radius: 10px;
    font-weight: bold;
    margin-bottom: 90px;
  }

  .btn-submit{
    //margin-top: 50px;
    background-color: #ffffff;
    border: none;
    //border-radius: 10px;
    font-size: 1rem;
    font-weight: bold;
    cursor: pointer;
    border-bottom: 1px solid rgba(31, 121, 156, 0.31);
    //margin-left: 40%;
    color: $light-orange;
    &:focus, &:hover{
      color: #017486;
      box-shadow: none;
    }

    @media (min-width: 1400px) {
      font-size: 1.3rem;
      margin-top: 50px;
    }
  }

  .talk{
    @media (max-width: 994px) {
      padding-bottom: 25vh;
    }

    @media (max-width: 774px) {
      padding-bottom: 25vh;
    }

    @media (max-width: 594px) {
      padding-bottom: 30vh;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/Gratitude.vue